// Pathify
import { make } from 'vuex-pathify'
import i18n from '../../i18n'
// Data
const state = {
    version: process.env.MIX_VUE_APP_VERSION,
    drawer: null,
    drawerImage: true,
    mini: false,
    appBarTitle: i18n.t('home'),
    items: [
        {
            title: i18n.t('home'),
            icon: 'mdi-home',
            to: '/',
            permission: 'noCheck'
        },
        {
            title: i18n.t('webconference'),
            icon: 'mdi-monitor-account',
            items: [
                {
                    title: i18n.t('bbb_server'),
                    icon: 'mdi-alpha-b-circle-outline',
                    to: '/server/bbb',
                    permission: 'virtual_machine_list'
                },
                {
                    title: i18n.t('loadbalancer_server'),
                    icon: 'mdi-scale-balance',
                    to: '/server/lb',
                    permission: 'virtual_machine_list'
                },
                {
                    title: i18n.t('vm'),
                    icon: 'mdi-server',
                    to: '/server/vm',
                    permission: 'virtual_machine_list'
                },
                {
                    title: i18n.t('meetings'),
                    icon: 'mdi-google-classroom',
                    to: '/server/meetings',
                    permission: 'virtual_machine_all_meeting_list'
                },
                {
                    title: i18n.t('bbb_styles'),
                    icon: 'mdi-format-line-style',
                    to: '/server/styles',
                    permission: 'config_style_list'
                },
            ]

        },
        {
            title: i18n.t('lms'),
            icon: 'mdi-school-outline',
            items: [
                {
                    title: i18n.t('dashboard'),
                    icon: 'mdi-view-dashboard',
                    to: '/lms/dashboard',
                    permission: 'e_learning_courses_list'
                },
                {
                    title: i18n.t('course'),
                    icon: 'mdi-book-open-variant',
                    to: '/lms/course',
                    permission: 'e_learning_courses_list'
                }
                , {
                    title: i18n.t('professor'),
                    icon: 'mdi-human-male-board',
                    to: '/lms/professor',
                    permission: 'e_learning_professors_list'
                }
                ,
                {
                    title: i18n.t('student'),
                    icon: 'mdi-account-school-outline',
                    to: '/lms/student',
                    permission: 'e_learning_students_list'
                },
                {
                    title: i18n.t('update_lms'),
                    icon: 'mdi-database-sync-outline',
                    to: '/lms/update',
                    permission: ['golestan_fetch_enrollments_1083',
                        'e_learning_moodle_enrollments',
                        'e_learning_moodle_allocations',
                        'golestan_get_categories_1030',
                        'e_learning_create_bigbluebutton_meetings'],
                    permissionOperator: 'or'
                },
                {
                    title: i18n.t('lms_config'),
                    icon: 'mdi-cog-box',
                    to: '/lms/config/',
                    permission: ['config_moodle_show_all',
                        'config_golestan_show_all'],
                    permissionOperator: 'or'
                }
            ]
        },
        {
            title: i18n.t('webinar_plus'),
            icon: 'mdi-alpha-w-circle-outline',
            items: [
                {
                    title: i18n.t('webinar_plus_list'),
                    icon: 'mdi-format-list-bulleted',
                    to: '/webinarplus/list',
                    permission: 'webinar_plus_company_list'
                },
                {
                    title: i18n.t('webinar_plus_config'),
                    icon: 'mdi-cog-box',
                    to: '/webinarplus/config',
                    permission: 'webinar_plus_default_get'
                },
                {
                    title: i18n.t('webinar_plus_users'),
                    icon: 'mdi-account-group',
                    to: '/webinarplus/users',
                    permission: 'webinar_plus_user_list'
                }
            ]

        },
        {
            title: i18n.t('sms'),
            icon: 'mdi-message-processing-outline',
            items: [
                {
                    title: i18n.t('sms_panels'),
                    icon: 'mdi-message-cog-outline',
                    to: '/sms/panels',
                    permission: 'config_sms_setting_list'
                },
                {
                    title: i18n.t('sms_tokens'),
                    icon: 'mdi-message-lock-outline',
                    to: '/sms/tokens',
                    permission: 'config_sms_token_list'
                },
                {
                    title: i18n.t('sms_logs'),
                    icon: 'mdi-message-question-outline',
                    to: '/sms/logs',
                    permission: 'config_sms_log_list'
                }

            ]
        },
        {
            title: i18n.t('settings'),
            icon: 'mdi-cog-outline',
            items: [
                {
                    title: i18n.t('users'),
                    icon: 'mdi-account-group',
                    to: '/users',
                    permission: 'user_list'
                }

            ]
        }
    ],
}

const mutations = make.mutations(state)

const actions = {
    ...make.actions(state),
    init: async ({ dispatch }) => {

    },
}

const getters = {}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
